import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  BreederLitterListGetBreedQuery,
  BreederLitterListGetBreedQueryVariables,
} from '@gql/graphql';
import { useMemo } from 'react';

export const BREEDER_LITTER_LIST_GET_BREED = graphql(`
  query BreederLitterListGetBreed($take: Int, $where: DogBreedWhereInput) {
    findManyDogBreed(where: $where, take: $take) {
      id
      name
      headShape
      fciGroup
      hairType

      imgs {
        id
        type
        small
        medium
        large
      }

      translations {
        id
        language
        name
        description
        otherNames
      }
    }
  }
`);

export const useGetBreed = (name?: string) => {
  const { language } = useRouter();

  const variables: BreederLitterListGetBreedQueryVariables = useMemo(() => {
    return {
      take: 1,
      where: {
        OR: [{ name: { equals: name } }, { baseBreedName: { equals: name } }],
        translations: {
          some: {
            language: { equals: language },
            AND: [
              { description: { not: { equals: '' } } },
              { description: { not: { equals: null } } },
            ],
          },
        },
        isSubBreed: { equals: false },
      },
    } as BreederLitterListGetBreedQueryVariables;
  }, [name, language]);

  const { data, error, loading } = useQuery<
    BreederLitterListGetBreedQuery,
    BreederLitterListGetBreedQueryVariables
  >(BREEDER_LITTER_LIST_GET_BREED, {
    variables,
    skip: !name,
  });

  return {
    breed: data?.findManyDogBreed?.[0],
    breedError: error,
    breedLoading: loading,
  };
};
